export const agreementRoutes = [
  // 隐私政策
  {
    path: "/agreement/xxqd",
    name: "xxqd",
    meta: {
      isKeepAlive: false,
      title: "第三方共享信息清单",
    },
    component: () => import("@/components/xxqd/index.vue"),
  },
  //
  {
    path: "/agreement/grxxqd",
    name: "grxxqd",
    meta: {
      isKeepAlive: false,
      title: "个人信息清单",
    },
    component: () => import("@/components/grxxqd/index.vue"),
  },
  //
  {
    path: "/agreement/privacy-policy",
    name: "privacy-policy",
    meta: {
      isKeepAlive: false,
      title: "隐私政策",
    },
    component: () => import("@/components/privacy-policy/index.vue"),
  },
  // 服务协议
  {
    path: "/agreement/service-agreement",
    name: "service-agreement",
    meta: {
      isKeepAlive: false,
      title: "服务协议",
    },
    component: () => import("@/components/service-agreement/index.vue"),
  },
  // 帮助反馈
  {
    path: "/agreement/help-feedback",
    name: "help-feedback",
    meta: {
      isKeepAlive: false,
      title: "帮助反馈",
    },
    component: () => import("@/components/help-feedback/index.vue"),
  },
  {
    path: "/agreement/disclaimers",
    name: "disclaimers",
    meta: {
      isKeepAlive: false,
      title: "免责声明",
    },
    component: () => import("@/components/disclaimers/index.vue"),
  },
  {
    path: "/agreement/shipping",
    name: "shippingAis",
    meta: {
      isKeepAlive: false,
      title: "AIS数据接收器购买",
    },
    component: () => import("@/components/shipping/index.vue"),
  },
  {
    path: "/agreement/charge",
    name: "vipCharge",
    meta: {
      isKeepAlive: false,
      title: "海e行会员服务收费协议",
    },
    component: () => import("@/components/charge/index.vue"),
  },
  {
    path: "/agreement/behavior",
    name: "userBehavior",
    meta: {
      isKeepAlive: false,
      title: "用户行为规范",
    },
    component: () => import("@/components/behavior/index.vue"),
  },
  {
    path: "/agreement/hst-privacy-policy",
    name: "hst-privacy-policy",
    meta: {
      isKeepAlive: false,
      title: "海上通隐私权政策",
    },
    component: () => import("@/components/hst-privacy-policy/index.vue"),
  },
  {
    path: "/agreement/merchantService",
    name: "merchantService",
    meta: {
      isKeepAlive: false,
      title: "易航海商店关店协议",
    },
    component: () => import("@/components/merchantService/index.vue"),
  },
];
